import { createWebHistory, createRouter, Router, RouterHistory } from 'vue-router';
import { globalAuthGuard } from '@/router/guards';
import mainRoutes from '@/router/routes/mainRoutes';

const history: RouterHistory = createWebHistory();

const router: Router = createRouter({
	history: history,
	routes: mainRoutes,
});

router.beforeEach(globalAuthGuard);

export default router;
